import { View } from 'react-native';

import { Skeleton } from '@/components/_shared/Skeleton';

import { styles } from './styles';
import type { ServiceCategoryBreadcrumbSkeletonProps } from './types';

const AVATAR_SIZE = 24;

export const ServiceCategoryBreadcrumbSkeleton = ({
  testID = 'service-category-breadcrumb-skeleton',
}: ServiceCategoryBreadcrumbSkeletonProps) => (
  <View testID={testID} style={styles.container}>
    <Skeleton variant="circular" width={AVATAR_SIZE} height={AVATAR_SIZE} />
    <Skeleton variant="text" width={120} height={16} />
  </View>
);
